import { GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid'

export const defaultSortModel: GridSortModel = [{ field: 'startDate', sort: 'desc' }]

export const defaultVisibilityModel: GridColumnVisibilityModel = {
  __newStatus: false,
  deal_end_date: false,
  dealStage: false,
  dealType: false,
  dealStatus: false,
  owner: false,
  _resolvedOwner: false,
}

export const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
}
export const defaultColumnOrder: string[] = [
  'productName',
  'organizationName',
  'price',
  'netTotal',
  'mediaSpend',
  '_resolvedOwner',
  'dealName',
  'dealStatus',
  'dealType',
  'dealStage',
  'contractId',
  'category',
  'category_name',
  'subcategory',
  'status',
  'startDate',
  'endDate',
]
